// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__lewXA","header":"ReportDetails_header__tOqp5","title":"ReportDetails_title__3dgSs","left":"ReportDetails_left__3wgvY"};